// extracted by mini-css-extract-plugin
export default {"container":"EmptyList_container__JwElJ","containerImg":"EmptyList_containerImg__y4hR0"};